var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBuildingTransparent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5975 1.0587C12.2667 0.730432 11.7331 0.730432 11.4023 1.0587L7.89342 4.54123C7.73295 4.7005 7.64269 4.91724 7.64269 5.14333V6.61671H1.47319C1.00468 6.61671 0.624878 6.99651 0.624878 7.46501V23.7168C0.624878 24.1853 1.00468 24.5651 1.47319 24.5651H22.5266C22.9951 24.5651 23.3749 24.1853 23.3749 23.7168V12.1084C23.3749 11.6399 22.9951 11.2601 22.5266 11.2601H16.3571V5.14333C16.3571 4.91724 16.2669 4.7005 16.1064 4.54123L12.5975 1.0587ZM9.3393 7.46501V5.49659L11.9999 2.85599L14.6605 5.49659V12.1084C14.6605 12.5769 15.0403 12.9567 15.5088 12.9567H21.6783V22.8685H2.32149V8.31332H8.491C8.95951 8.31332 9.3393 7.93352 9.3393 7.46501ZM6.14574 21.3907H3.80647V19.069H6.14574V21.3907ZM6.14574 16.7473H3.80647V14.4256H6.14574V16.7473ZM6.14574 12.104H3.80647V9.78228H6.14574V12.104ZM10.8243 21.3907V19.069H13.1636V21.3907H10.8243ZM10.8243 16.7473V14.4256H13.1636V16.7473H10.8243ZM10.8243 12.104V9.78228H13.1636V12.104H10.8243ZM10.8243 7.46059V5.13891H13.1636V7.46059H10.8243ZM20.1814 21.3907H17.8421V19.069H20.1814V21.3907ZM20.1814 16.7473H17.8421V14.4256H20.1814V16.7473Z",
    fill: "#BE5400"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBuildingTransparent);
export default __webpack_public_path__ + "static/media/icon-building-transparent.996b0aaab46145083612473693e12a3a.svg";
export { ForwardRef as ReactComponent };